import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { PreSigned, Resource } from '../models';
import { TemplateType, TransactionType } from '../enums';

const API_BASE = environment.PROCESS_NAVIGATOR_BASE;

@Injectable()
export class ProcessNavigatorService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  createPreSigned(name: string): Observable<{ data: PreSigned }> {
    return this.http.post<{ data: PreSigned }>(
      `${API_BASE}/companies/${this.companyId}/resources/presigned_url`,
      { name },
    );
  }

  getPreSigned(uuid: string): Observable<{ data: PreSigned }> {
    return this.http.post<{ data: PreSigned }>(
      `${API_BASE}/companies/${this.companyId}/resources/get_presigned_url`,
      { uuid },
    );
  }

  upload(url: string, file: File): Observable<HttpResponse<void>> {
    return this.http.put<void>(url, file, { observe: 'response' });
  }

  createUpdateResources(
    templateId: number,
    templateType: TemplateType,
    resources: Partial<Resource>[],
  ): Observable<{ data: { resources: Resource[] } }> {
    return this.http.put<{ data: { resources: Resource[] } }>(
      `${API_BASE}/companies/${this.companyId}/resources/templates/${templateId}?template_type=${templateType}`,
      { resources },
    );
  }

  getResources(templateId: number, templateType: TemplateType): Observable<{ data: Resource[] }> {
    return this.http.get<{ data: Resource[] }>(
      `${API_BASE}/companies/${this.companyId}/resources/templates/${templateId}?template_type=${templateType}`,
    );
  }

  startResourceTracker(
    resourceId: number,
    transactionId: number,
    transactionType: TransactionType,
  ): Observable<{ data: { id: number } }> {
    return this.http.get<{ data: { id: number } }>(
      `${API_BASE}/companies/${this.companyId}/resources/${resourceId}/tracker?transaction_id=${transactionId}&transaction_type=${transactionType}`,
    );
  }

  closeResourceTracker(resourceId: number, trackerId: number): Observable<HttpResponse<void>> {
    return this.http.get<void>(
      `${API_BASE}/companies/${this.companyId}/resources/${resourceId}/tracker/${trackerId}/close`,
      { observe: 'response' },
    );
  }
}
